import { render } from "./RejectOpenShopApply.vue?vue&type=template&id=525f575c&scoped=true"
import script from "./RejectOpenShopApply.vue?vue&type=script&lang=js"
export * from "./RejectOpenShopApply.vue?vue&type=script&lang=js"

import "./RejectOpenShopApply.vue?vue&type=style&index=0&id=525f575c&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525f575c"]])

export default __exports__